type AuthOptionProps = {
  label: string;
  onSelect: () => void;
  selected: boolean;
};

export default function AuthOption({ label, onSelect, selected }: AuthOptionProps) {
  return (
    <button
      className={`auth-option w-full text-left ${selected ? "auth-option-selected" : ""}`}
      onClick={onSelect}
      type="button"
    >
      <span className="flex items-center gap-3">
        <span className={`auth-radio ${selected ? "auth-radio-selected" : ""}`}>
          {selected && <span className="auth-radio-dot auth-radio-dot-selected" />}
        </span>
        <span className="text-sm font-medium text-gray-700">{label}</span>
      </span>
    </button>
  );
}
